const Logo = () => {
  return <img src='/assets/images/logo.svg' />;
};

export default Logo;
